import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 600px;
  padding: 40px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
  position: relative;
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const DomainListContainer = styled.div`
  display: flex;
  max-height: 240px;
  align-items: flex-start;
  align-self: stretch;
  overflow-y: auto;
  flex-direction: column;
  box-sizing: border-box;

  border-top: 1px solid var(--alias-color-line-normal);
`;

export const AgreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`;

export const AgreeCheckBoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const AgreeAnnotationContainer = styled.div`
  display: flex;
  padding-left: 28px;
  align-items: center;
  align-self: stretch;
`;

export const TermContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  cursor: pointer;

  span {
    display: inline-block;
    vertical-align: middle;
    transform: translateY(-1.5px);
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;


export const CancelBtnContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

